import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {OpeLog,TypeOpeLog} from "@domain/admin/ca/ope-log";
import {ListView} from "@domain/common/list-view";

/**
 * Composant d'un item déplié de la liste du suivi des relevés
 *
 * @author Guillaume TRAVOT
 * @date 18/03/2026
 */
@Component({
    host: {'data-test-id': 'suivi-releve-history-item'},
    selector: 'suivi-releve-history-item',
    templateUrl: './suivi-releve-history-item.component.html',
    styleUrls: ['./suivi-releve-history-item.component.scss']
})
export class SuiviReleveHistoryItemComponent implements OnInit {
    /** Référence à la liste */
    @Input() public liste: ListView<OpeLog,any>;

    /** Log concerné */
    @Input() opeLog: OpeLog;

    /** Événement d'ouverture de la liste des erreurs */
    @Output() onOpenErrorList = new EventEmitter<{idLot: number, isLastOpe: boolean}>();

    /** Type de log à afficher */
    typeLibelle: string;

    /** Indique la réintégration */
    isReintegration: boolean;

    /** Indique la présence d'erreurs */
    hasErrors: boolean;

    /** Indique la possibilité de supprimer */
    canDelete: boolean;

    /**
     * Constructeur
     */
    constructor(
        private translateService: TranslateService
    ) {}

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Détermination de réintégration
        this.isReintegration = this.opeLog.typeOpeLog === TypeOpeLog.REINTEGRATION;

        //Détermination de la présence d'erreurs
        this.hasErrors = this.opeLog.nbErreur > 0 || this.opeLog.nbExclue > 0 || this.opeLog.nbRejet > 0;

        //Détermination de la possibilité de supprimer
        this.canDelete = this.opeLog.isLastOpe && this.isReintegration;

        //Détermination du type à afficher
        switch (this.opeLog.typeOpeLog) {
            case TypeOpeLog.IMPORT:
                this.typeLibelle = this.translateService.instant('admin.frais.cartes.suivi.typeImport');
                break;
            case TypeOpeLog.REINTEGRATION:
                this.typeLibelle = this.translateService.instant('admin.frais.cartes.suivi.typeReintegration');
                break;
            default:
                this.typeLibelle = '';
        }
    }

    /**
     * Ouvre la liste des erreurs
     */
    openErrorList(): void {
        if (this.hasErrors) {
            this.onOpenErrorList.emit({
                idLot: this.opeLog.idOpeLog,
                isLastOpe: this.opeLog.isLastOpe
            });
        }
    }
}